var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EMPTY } from "rxjs";
import { TypeActionDependencyInjection, } from "./actionDependencyInjection";
var initial = {
    viewportChanged$: EMPTY,
};
export var reducerDependencyInjection = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionDependencyInjection.Inject) {
        return __assign({}, state, action.deps);
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/dep-injection/reducerDependencyInjection.ts
// module id = 2523
// module chunks = 3